function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//@ts-nocheck
export class IndexPath {
  constructor(row, section) {
    this.row = row;
    this.section = section;

    _defineProperty(this, "equals", other => {
      if (!other) {
        return false;
      }

      return this.row === other.row && this.section === other.section;
    });
  }

  get groupIndex() {
    return this.section >= 0 && new IndexPath(this.row);
  }

  toString() {
    if (this.section >= 0) {
      return `${this.section + 1}.${this.row + 1}`;
    }

    return (this.row + 1).toString();
  }

}
/*
 * @see https://github.com/piotrwitek/utility-types#overwritet-u
 */